// Angular
import { Component } from '@angular/core';
import {LayoutConfigService} from '../../../../core/_base/layout';
import {DrawingService} from '../../../pages/services/drawing.service';

@Component({
  selector: 'kt-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
  searchDisplay = false;
  notificationsDisplay = false;
  quickActionsDisplay = false;
  cartDisplay = false;
  quickPanelDisplay = false;
  languagesDisplay = false;
  userDisplay = false;
  toolDisplay = false;
  userLayout = 'offcanvas';
  userDropdownStyle = 'light';

  constructor(private layoutConfigService: LayoutConfigService, private drawingService: DrawingService) {
    this.drawingService.getMessage().subscribe(res => {
      if(res) {
        this.toolDisplay = true;
      } else {
        this.toolDisplay = false;
      }
    });
    this.searchDisplay = this.layoutConfigService.getConfig('extras.search.display');
    this.notificationsDisplay = this.layoutConfigService.getConfig('extras.notifications.display');
    this.quickActionsDisplay = this.layoutConfigService.getConfig('extras.quick-actions.display');
    this.cartDisplay = this.layoutConfigService.getConfig('extras.cart.display');
  //  this.quickPanelDisplay = this.layoutConfigService.getConfig('extras.quick-panel.display');
    this.languagesDisplay = this.layoutConfigService.getConfig('extras.languages.display');
    this.userDisplay = this.layoutConfigService.getConfig('extras.user.display');
    this.userLayout = this.layoutConfigService.getConfig('extras.user.layout');
    this.userDropdownStyle = this.layoutConfigService.getConfig('extras.user.dropdown.style');
  }

  // toolClick(message) {
  //   console.log('top component click')
  //   this.drawingService.toolSubject.next(message);
  // }
}
